import { useState, useEffect, useCallback, useMemo } from "react";

import { API } from "../config";

// ── Stili comuni (coerenti con MonitorLive.js) ──────────────────
const FONT = "'DM Sans', sans-serif";
const MONO = "'IBM Plex Mono', monospace";

const stili = {
  card: {
    background: "#fff", borderRadius: 10,
    border: "1px solid #E2E8F0",
    padding: "16px 20px", marginBottom: 16,
  },
  intestazioneCard: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", marginBottom: 14,
    flexWrap: "wrap", gap: 12,
  },
  titoloCardWrapper: {
    display: "flex", alignItems: "center", gap: 8,
  },
  titoloCard: {
    fontSize: 15, fontWeight: 700, color: "#1E293B", margin: 0,
  },
  sottotitolo: {
    fontSize: 12, color: "#64748B", marginTop: 2,
  },
  // ── Filtro stagione ─────────────────────────────────────────
  filtroWrapper: {
    display: "flex", alignItems: "center", gap: 8,
  },
  filtroLabel: {
    fontSize: 12, fontWeight: 600, color: "#475569",
    fontFamily: FONT,
  },
  selectFiltro: {
    fontFamily: FONT, fontSize: 13, padding: "6px 10px",
    borderRadius: 6, border: "1px solid #CBD5E1",
    background: "#fff", color: "#1E293B", outline: "none",
    cursor: "pointer", minWidth: 180,
  },
  // ── Tabella ─────────────────────────────────────────────────
  tabella: {
    width: "100%", borderCollapse: "collapse", fontFamily: FONT,
  },
  th: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "left",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC",
  },
  thNum: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "right",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC",
  },
  td: {
    fontSize: 13, padding: "9px 10px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    fontFamily: FONT,
  },
  tdNum: {
    fontSize: 13, padding: "9px 10px", color: "#334155",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    fontFamily: MONO, textAlign: "right",
  },
  badgeDecisione: {
    display: "inline-block", padding: "2px 10px",
    borderRadius: 12, fontSize: 11, fontWeight: 600,
  },
  // ── Onboarding (nessuna stagione) ───────────────────────────
  onboardingBox: {
    textAlign: "center", padding: "60px 24px",
    background: "#F8FAFC", borderRadius: 8,
    border: "1px dashed #CBD5E1",
  },
  onboardingIcona: {
    fontSize: 40, marginBottom: 16,
  },
  onboardingTitolo: {
    fontSize: 18, fontWeight: 700, color: "#1E293B",
    marginBottom: 10,
  },
  onboardingTesto: {
    fontSize: 13, color: "#64748B",
    maxWidth: 480, margin: "0 auto 6px auto", lineHeight: 1.5,
  },
  errore: {
    background: "#FFEBEE", color: "#C62828",
    padding: "10px 12px", borderRadius: 6,
    fontSize: 12, marginBottom: 14,
  },
  vuoto: {
    textAlign: "center", color: "#94A3B8",
    padding: "30px 16px", fontSize: 13,
  },
  // ── Colonna Azioni e tasto Elimina ──────────────────────────
  thAzioni: {
    fontSize: 11, fontWeight: 700, color: "#64748B",
    padding: "8px 10px", textAlign: "center",
    borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap",
    background: "#F8FAFC", width: "1%",
  },
  tdAzioni: {
    fontSize: 13, padding: "9px 10px",
    borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap",
    textAlign: "center",
  },
  bottoneElimina: {
    fontFamily: FONT, fontSize: 12, fontWeight: 600,
    padding: "4px 10px", borderRadius: 6,
    border: "1px solid #FCA5A5", background: "#fff",
    color: "#C62828", cursor: "pointer",
    transition: "background 0.15s",
  },
  // ── Cella note editabile inline ─────────────────────────────
  tdNote: {
    fontSize: 13, padding: "9px 10px",
    borderBottom: "1px solid #F1F5F9",
    fontFamily: FONT,
    cursor: "pointer",
    minWidth: 120,
    transition: "background 0.15s",
  },
  inputNoteInline: {
    fontFamily: FONT, fontSize: 13,
    padding: "4px 6px", borderRadius: 4,
    border: "1px solid #2563EB",
    color: "#1E293B", outline: "none",
    width: "100%", boxSizing: "border-box",
    background: "#fff",
  },
  feedbackNote: {
    fontSize: 11, color: "#94A3B8", fontStyle: "italic",
    marginLeft: 6,
  },
  // ── Modal conferma eliminazione ─────────────────────────────
  modalOverlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(15, 23, 42, 0.4)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000,
  },
  modalBox: {
    background: "#fff", borderRadius: 10,
    padding: "24px 28px", maxWidth: 480,
    boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
    fontFamily: FONT,
  },
  modalTitolo: {
    fontSize: 16, fontWeight: 700, color: "#1E293B",
    marginBottom: 10,
  },
  modalTesto: {
    fontSize: 13, color: "#475569", lineHeight: 1.5,
    marginBottom: 20,
  },
  modalAzioni: {
    display: "flex", justifyContent: "flex-end", gap: 8,
  },
  bottoneAnnulla: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "1px solid #CBD5E1", background: "#fff",
    color: "#64748B", cursor: "pointer",
  },
  bottoneConferma: {
    fontFamily: FONT, fontSize: 13, fontWeight: 600,
    padding: "8px 14px", borderRadius: 6,
    border: "none", background: "#DC2626", color: "#fff",
    cursor: "pointer",
  },
};

// v125: solo 2 decisioni, con palette dedicata
const COLORI_DECISIONE = {
  "Capitale di inizio stagione":   { bg: "#E0F2FE", color: "#075985" },
  "Allineamento capitale operativo": { bg: "#FEF3C7", color: "#92400E" },
};

function formatEur(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!isFinite(n)) return "—";
  const negativo = n < 0;
  const abs = Math.abs(n);
  const intero = Math.trunc(abs);
  const dec = Math.round((abs - intero) * 100);
  const decStr = String(dec).padStart(2, "0");
  const interoStr = String(intero).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return (negativo ? "-" : "") + interoStr + "," + decStr + " €";
}

function formatData(s) {
  if (!s) return "—";
  // ISO YYYY-MM-DD -> DD/MM/YYYY
  const parts = String(s).slice(0, 10).split("-");
  if (parts.length !== 3) return s;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

// ════════════════════════════════════════════════════════════════
// Componente principale — Tab Capitale (sola lettura, v125)
// ════════════════════════════════════════════════════════════════
export default function DiarioCapitale() {
  const [revisioni, setRevisioni] = useState([]);
  const [stagioni, setStagioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(null);

  // Filtro stagione: "all" | id stagione (numero come string)
  const [filtroStagioneId, setFiltroStagioneId] = useState("all");

  // Modal conferma eliminazione: null | { id, decisione, valore, errore? }
  const [modalElimina, setModalElimina] = useState(null);
  const [eliminandoId, setEliminandoId] = useState(null);

  // v125: editing inline cella Note: null oppure { id, valore }
  const [noteInEdit, setNoteInEdit] = useState(null);
  const [salvataggioNote, setSalvataggioNote] = useState(false);
  const [erroreNote, setErroreNote] = useState(null);

  const ricarica = useCallback(async () => {
    setLoading(true);
    setErrore(null);
    try {
      const [rt, rs] = await Promise.all([
        fetch(`${API}/diario/capitale/tagliandi`),
        fetch(`${API}/diario/stagioni`),
      ]);
      if (!rt.ok) throw new Error(`HTTP tagliandi ${rt.status}`);
      if (!rs.ok) throw new Error(`HTTP stagioni ${rs.status}`);
      const dt = await rt.json();
      const ds = await rs.json();
      setRevisioni(Array.isArray(dt) ? dt : []);
      setStagioni(Array.isArray(ds) ? ds : []);
    } catch (e) {
      setErrore(e.message || "Errore di rete");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { ricarica(); }, [ricarica]);

  // v125: eliminazione riga storico (chiama DELETE backend)
  const confermaElimina = async () => {
    if (!modalElimina) return;
    const id = modalElimina.id;
    setEliminandoId(id);
    try {
      const r = await fetch(`${API}/diario/capitale/tagliandi/${id}`, { method: "DELETE" });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      // Aggiorno tabella in locale rimuovendo la riga
      setRevisioni((prev) => prev.filter((row) => row.id !== id));
      setModalElimina(null);
    } catch (e) {
      setModalElimina((prev) => prev && { ...prev, errore: e.message });
    } finally {
      setEliminandoId(null);
    }
  };

  // v125: editing inline note
  const apriEditNote = (riga) => {
    setErroreNote(null);
    setNoteInEdit({ id: riga.id, valore: riga.note || "" });
  };
  const annullaEditNote = () => {
    if (salvataggioNote) return;
    setNoteInEdit(null);
    setErroreNote(null);
  };
  const salvaNote = async () => {
    if (!noteInEdit || salvataggioNote) return;
    const { id, valore } = noteInEdit;
    setSalvataggioNote(true);
    setErroreNote(null);
    try {
      const r = await fetch(`${API}/diario/capitale/tagliandi/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: valore }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data.errore) throw new Error(data.errore);
      // Aggiorno tabella in locale
      setRevisioni((prev) =>
        prev.map((row) => (row.id === id ? { ...row, note: valore } : row))
      );
      setNoteInEdit(null);
    } catch (e) {
      setErroreNote(e.message || "Errore di rete");
    } finally {
      setSalvataggioNote(false);
    }
  };

  // Mappa id_stagione -> etichetta
  const stagioneEtichetta = useMemo(() => {
    const m = {};
    for (const s of stagioni) {
      m[s.id] = s.etichetta || `Stagione #${s.id}`;
    }
    return m;
  }, [stagioni]);

  // Applico filtro stagione
  const revisioniFiltrate = useMemo(() => {
    if (filtroStagioneId === "all") return revisioni;
    const idNum = Number(filtroStagioneId);
    return revisioni.filter(r => Number(r.stagione_id) === idNum);
  }, [revisioni, filtroStagioneId]);

  // ── Stato vuoto / onboarding (nessuna stagione) ───────────────
  if (!loading && stagioni.length === 0) {
    return (
      <div style={stili.card}>
        <div style={stili.intestazioneCard}>
          <div style={stili.titoloCardWrapper}>
            <h2 style={stili.titoloCard}>Capitale</h2>
          </div>
        </div>

        {errore && <div style={stili.errore}>{errore}</div>}

        <div style={stili.onboardingBox}>
          <div style={stili.onboardingIcona}>💼</div>
          <div style={stili.onboardingTitolo}>Nessuna stagione configurata</div>
          <div style={stili.onboardingTesto}>
            Per iniziare a usare il Diario Operativo, vai nella tab
            <strong> ⚙️ Impostazioni → Stagioni</strong> e crea la stagione corrente
            indicando il <strong>capitale di inizio stagione</strong>.
          </div>
          <div style={stili.onboardingTesto}>
            Lo storico in questa pagina si popolerà automaticamente.
          </div>
        </div>
      </div>
    );
  }

  // ── Stato normale: tabella storico ────────────────────────────
  return (
    <div style={stili.card}>
      <div style={stili.intestazioneCard}>
        <div>
          <div style={stili.titoloCardWrapper}>
            <h2 style={stili.titoloCard}>Storico revisioni capitale</h2>
          </div>
          <div style={stili.sottotitolo}>
            Le righe vengono create automaticamente quando configuri o modifichi i capitali nella tab Impostazioni → Stagioni.
          </div>
        </div>

        {/* Filtro per stagione */}
        <div style={stili.filtroWrapper}>
          <span style={stili.filtroLabel}>Stagione:</span>
          <select
            style={stili.selectFiltro}
            value={filtroStagioneId}
            onChange={(e) => setFiltroStagioneId(e.target.value)}
            title="Filtra lo storico per stagione"
          >
            <option value="all">Tutte le stagioni</option>
            {stagioni.map(s => (
              <option key={s.id} value={String(s.id)}>
                {s.etichetta || `Stagione #${s.id}`}
              </option>
            ))}
          </select>
        </div>
      </div>

      {errore && <div style={stili.errore}>{errore}</div>}

      {loading ? (
        <div style={stili.vuoto}>Caricamento...</div>
      ) : revisioniFiltrate.length === 0 ? (
        <div style={stili.vuoto}>
          Nessuna revisione registrata{filtroStagioneId !== "all" ? " per la stagione selezionata" : ""}.
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={stili.tabella}>
            <thead>
              <tr>
                <th
                  style={stili.th}
                  title="La data a cui si riferisce la riga"
                >
                  Data
                </th>
                <th
                  style={stili.th}
                  title="La stagione a cui si riferisce la riga"
                >
                  Stagione
                </th>
                <th
                  style={stili.th}
                  title="Tipo di operazione: 'Capitale di inizio stagione' o 'Allineamento capitale operativo'"
                >
                  Decisione
                </th>
                <th
                  style={stili.thNum}
                  title="Valore del capitale operativo precedente all'allineamento (vuoto per le righe di inizio stagione)"
                >
                  Valore precedente
                </th>
                <th
                  style={stili.thNum}
                  title="Valore impostato del capitale (di inizio stagione o allineamento)"
                >
                  Valore
                </th>
                <th style={{ ...stili.th, minWidth: 140 }}>Note</th>
                <th style={stili.thAzioni}>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {revisioniFiltrate.map(t => {
                const valore = Number(t.capitale_riferimento_eur || 0);
                const precedente = t.capitale_operativo_precedente_eur;
                const colDec = COLORI_DECISIONE[t.decisione]
                  || { bg: "#F1F5F9", color: "#475569" };
                return (
                  <tr key={t.id}>
                    <td style={stili.td}>{formatData(t.da_data)}</td>
                    <td style={stili.td}>
                      {stagioneEtichetta[t.stagione_id] || "—"}
                    </td>
                    <td style={stili.td}>
                      <span style={{
                        ...stili.badgeDecisione,
                        background: colDec.bg, color: colDec.color,
                      }}>
                        {t.decisione}
                      </span>
                    </td>
                    <td
                      style={{
                        ...stili.tdNum,
                        color: precedente != null ? "#64748B" : "#CBD5E1",
                        fontStyle: precedente != null ? "normal" : "italic",
                      }}
                    >
                      {precedente != null ? formatEur(precedente) : "—"}
                    </td>
                    <td style={stili.tdNum}>
                      <strong>{formatEur(valore)}</strong>
                    </td>
                    {noteInEdit && noteInEdit.id === t.id ? (
                      <td style={stili.tdNote}>
                        <input
                          type="text"
                          autoFocus
                          style={stili.inputNoteInline}
                          value={noteInEdit.valore}
                          onChange={(e) => setNoteInEdit((prev) => prev && { ...prev, valore: e.target.value })}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") salvaNote();
                            else if (e.key === "Escape") annullaEditNote();
                          }}
                          onBlur={salvaNote}
                          disabled={salvataggioNote}
                          placeholder="Scrivi una nota..."
                        />
                        {erroreNote && (
                          <div style={{ ...stili.feedbackNote, color: "#C62828" }}>
                            Errore: {erroreNote}
                          </div>
                        )}
                      </td>
                    ) : (
                      <td
                        style={{
                          ...stili.tdNote,
                          color: t.note ? "#334155" : "#CBD5E1",
                          fontStyle: t.note ? "normal" : "italic",
                        }}
                        onClick={() => apriEditNote(t)}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#F8FAFC")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        title="Clicca per modificare la nota"
                      >
                        {t.note || "Aggiungi nota..."}
                      </td>
                    )}
                    <td style={stili.tdAzioni}>
                      <button
                        style={stili.bottoneElimina}
                        onClick={() => setModalElimina({
                          id: t.id,
                          decisione: t.decisione,
                          valore: t.capitale_riferimento_eur,
                          data: t.da_data,
                        })}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#FEF2F2")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                        title="Elimina questa riga dello storico"
                      >
                        🗑️ Elimina
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal conferma eliminazione riga */}
      {modalElimina && (
        <div style={stili.modalOverlay} onClick={() => setModalElimina(null)}>
          <div style={stili.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={stili.modalTitolo}>
              Eliminare questa riga dello storico?
            </div>
            <div style={stili.modalTesto}>
              <strong>{modalElimina.decisione}</strong> del{" "}
              <strong>{formatData(modalElimina.data)}</strong>, valore{" "}
              <strong>{formatEur(modalElimina.valore)}</strong>.
              <br /><br />
              L'operazione è permanente. I valori del capitale di inizio stagione e
              del capitale operativo nelle Impostazioni <strong>non verranno modificati</strong>:
              eliminare la riga dallo storico è un'operazione di solo "log".
            </div>
            {modalElimina.errore && (
              <div style={stili.errore}>Errore: {modalElimina.errore}</div>
            )}
            <div style={stili.modalAzioni}>
              <button
                style={stili.bottoneAnnulla}
                onClick={() => setModalElimina(null)}
                disabled={eliminandoId !== null}
              >
                Annulla
              </button>
              <button
                style={{
                  ...stili.bottoneConferma,
                  ...(eliminandoId !== null ? { opacity: 0.6, cursor: "wait" } : {}),
                }}
                onClick={confermaElimina}
                disabled={eliminandoId !== null}
              >
                {eliminandoId !== null ? "Eliminazione..." : "Conferma eliminazione"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
